declare var $: any;

export class Spinner {
    static spin($button: any) {
        const $spinner = $(".spinner", $button);
        $spinner.addClass("spinner--active");
        $button.attr("disabled", true);
        if ($spinner.html() === "") {
            $spinner.html("&nbsp;");
        }
    }

    static stop($button: any, enableButton = true, newLabel?: string) {
        const $spinner = $(".spinner", $button);
        $spinner.removeClass("spinner--active");
        if (enableButton) {
            $button.attr("disabled", false);
        }
        if ($spinner.html() === "&nbsp;") {
            $spinner.html("");
        }
        if (newLabel) {
            $spinner.html(newLabel);
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/spinner.ts